import React, { useEffect, useRef, useState } from "react";
import "../../css/Trips/RequestFullDataModal.css";

export default function RequestFullDataModal({
  isOpen,
  tripName,
  onClose,
  onConfirm,
  isLoading,
}) {
  const [reason, setReason] = useState("");
  const textareaRef = useRef(null);

  useEffect(() => {
    if (isOpen) setReason("");
  }, [isOpen]);

  useEffect(() => {
    if (!isOpen) return;

    const onKeyDown = (e) => {
      if (e.key === "Escape") onClose();
    };

    window.addEventListener("keydown", onKeyDown);
    return () => window.removeEventListener("keydown", onKeyDown);
  }, [isOpen, onClose]);

  useEffect(() => {
    if (isOpen) {
      setTimeout(() => textareaRef.current?.focus(), 0);
    }
  }, [isOpen]);

  if (!isOpen) return null;

  const handleConfirm = async () => {
    await onConfirm(reason?.trim() || null);
  };

  return (
    <div className="rf-overlay" onMouseDown={onClose}>
      <div className="rf-modal" onMouseDown={(e) => e.stopPropagation()}>
        <div className="rf-header">
          <div className="rf-header-text">
            <h3>Pobrać pełne dane?</h3>
            <p>
              Wycieczka: <strong>{tripName}</strong>
            </p>
          </div>

          <button
            type="button"
            className="rf-close"
            onClick={onClose}
            disabled={isLoading}
            aria-label="Zamknij"
            title="Zamknij"
          >
            ×
          </button>
        </div>

        <div className="rf-warning">
          <div className="rf-warning-title">Uwaga</div>
          <ul>
            <li>Pobierzesz dane osobowe osób uczestniczących (RODO).</li>
            <li>
              Dostęp jest rejestrowany: kto, kiedy, do jakiej wycieczki oraz
              podany powód.
            </li>
            <li>
              Zgodnie z zasadą minimalizacji pobieraj je tylko, gdy jest to
              niezbędne do realizacji zadań.
            </li>
          </ul>
        </div>

        <div className="rf-hint">
          Jeśli nie musisz widzieć danych osobowych, pozostań przy widoku
          ograniczonym.
        </div>

        <label className="rf-label">Powód pobrania (opcjonalnie)</label>
        <textarea
          ref={textareaRef}
          className="rf-textarea"
          value={reason}
          onChange={(e) => setReason(e.target.value)}
          disabled={isLoading}
        />

        <div className="rf-footer">
          <div
            type="button"
            className="rf-btn"
            onClick={onClose}
            disabled={isLoading}
          >
            Anuluj
          </div>

          <div
            type="button"
            className="rf-btn primary"
            onClick={handleConfirm}
            disabled={isLoading}
          >
            {isLoading ? "Pobieranie…" : "Pobierz pełne dane"}
          </div>
        </div>
      </div>
    </div>
  );
}
